import classNames from "classnames";
import type { ReactNode } from "react";
import { BaseButton } from "../Button/BaseButton.tsx";

export const Toggle = ({
  items,
  index,
  onIndexChange,
  className,
}: {
  items: ReactNode[];
  index: number;
  onIndexChange: (value: number) => void;
  className?: string;
}) => (
  <div
    className={classNames(
      "flex-row items-center p-050 bg-primary rounded-200 label-md-default",
      className,
    )}
  >
    {items.map((element, indexElement) => (
      <BaseButton
        key={indexElement}
        size="medium"
        className={classNames(
          "flex-fill py-050 px-100 rounded-100 min-w-0 items-center justify-center",
          index === indexElement
            ? "bg-button-surface-secondary-rest text-primary shadow-100"
            : "",
        )}
        onClick={() => onIndexChange(indexElement)}
      >
        <div className="truncate text-center">{element}</div>
      </BaseButton>
    ))}
  </div>
);
